import { Typography, Box, Divider } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useCountAnimation } from './useCountAnimation';

export const ElectoralCounter = ({ 
  democraticCount, 
  republicanCount, 
  shouldAnimate, 
  setShouldAnimate 
}) => {
  const animatedDemCount = useCountAnimation(democraticCount, 1000, shouldAnimate, setShouldAnimate);
  const animatedRepCount = useCountAnimation(republicanCount, 1000, shouldAnimate, setShouldAnimate);

  return (
    <Box sx={{
      padding: '10px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%'
    }}>
      {/* Democratic Counter */}
      <Box sx={{ 
        textAlign: 'center', 
        position: 'relative', 
        flex: 1,
        minWidth: '90px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}>
        <Typography variant="h6" sx={{ 
          color: '#0000CC', 
          fontWeight: 'bold', 
          fontSize: '0.8rem',
          whiteSpace: 'nowrap',
          marginBottom: '2px'
        }}>
          Democratic
        </Typography>
        <Typography variant="h4" sx={{ 
          color: '#0000CC', 
          marginBottom: 0, 
          fontSize: '1.8rem',
          lineHeight: 1,
          fontWeight: 'bold'
        }}>
          {animatedDemCount}
        </Typography>
        {animatedDemCount > animatedRepCount && (
          <CheckCircleIcon sx={{ 
            color: '#2e7d32', 
            fontSize: '1.1rem',
            position: 'absolute',
            bottom: '-12px',
            left: '50%',
            transform: 'translateX(-50%)'
          }} />
        )}
      </Box>
      {/* Center Section */}
      <Box sx={{ 
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '0 12px'
      }}>
        <Divider orientation="vertical" flexItem />
        <Box sx={{ 
          textAlign: 'center',
          minWidth: '40px'
        }}>
          <Typography sx={{ 
            color: '#666', 
            fontSize: '0.9rem',
            whiteSpace: 'nowrap',
            lineHeight: 1.1
          }}>
            270
          </Typography>
          <Typography sx={{ 
            color: '#666', 
            fontSize: '0.75rem',
            whiteSpace: 'nowrap',
            lineHeight: 1.1
          }}>
            to Win
          </Typography>
        </Box>
        <Divider orientation="vertical" flexItem />
      </Box>
      {/* Republican Counter */}
      <Box sx={{ 
        textAlign: 'center', 
        position: 'relative', 
        flex: 1,
        minWidth: '90px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}>
        <Typography variant="h6" sx={{ 
          color: '#CC0000', 
          fontWeight: 'bold', 
          fontSize: '0.8rem',
          whiteSpace: 'nowrap',
          marginBottom: '2px'
        }}>
          Republican
        </Typography>
        <Typography variant="h4" sx={{ 
          color: '#CC0000', 
          marginBottom: 0, 
          fontSize: '1.8rem',
          lineHeight: 1,
          fontWeight: 'bold'
        }}>
          {animatedRepCount}
        </Typography>
        {animatedRepCount > animatedDemCount && (
          <CheckCircleIcon sx={{ 
            color: '#2e7d32', 
            fontSize: '1.1rem',
            position: 'absolute',
            bottom: '-12px',
            left: '50%',
            transform: 'translateX(-50%)'
          }} />
        )}
      </Box>
    </Box>
  );
};